const dateFmt = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' })
const dateTimeFmt = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' })
const relativeFmt = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })

export function formatDate(iso: string | null | undefined) {
  return iso ? dateFmt.format(new Date(iso)) : '—'
}

export function formatDateTime(iso: string | null | undefined) {
  return iso ? dateTimeFmt.format(new Date(iso)) : '—'
}

const units: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 31_536_000],
  ['month', 2_592_000],
  ['week', 604_800],
  ['day', 86_400],
  ['hour', 3_600],
  ['minute', 60],
]

export function formatRelative(iso: string | null | undefined) {
  if (!iso) return '—'
  const seconds = Math.round((new Date(iso).getTime() - Date.now()) / 1000)
  for (const [unit, size] of units) {
    if (Math.abs(seconds) >= size) return relativeFmt.format(Math.round(seconds / size), unit)
  }
  return 'just now'
}

export const numberFmt = new Intl.NumberFormat()

const usdFmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' })

/** USD cents as money, e.g. 4900 → $49.00. */
export function formatUsd(cents: number) {
  return usdFmt.format(cents / 100)
}

/** USD cents as whole dollars, e.g. 322400 → $3,224 (cents only when there are some). */
export function formatMoney(cents: number) {
  const dollars = cents / 100
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: Number.isInteger(dollars) ? 0 : 2,
    maximumFractionDigits: Number.isInteger(dollars) ? 0 : 2,
  }).format(dollars)
}

/** Minutes as "2h 13m", "45m" or "1d 4h". */
export function formatMinutes(minutes: number) {
  const m = Math.round(minutes)
  if (m < 60) return `${m}m`
  if (m < 1440) return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`
  return `${Math.floor(m / 1440)}d ${Math.floor((m % 1440) / 60)}h`
}

/** How long ago, short: "9 min", "2 h", "3 d". */
export function formatAgo(iso: string | null | undefined) {
  if (!iso) return '—'
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000)
  if (s < 60) return 'now'
  if (s < 3600) return `${Math.floor(s / 60)} min`
  if (s < 86400) return `${Math.floor(s / 3600)} h`
  return `${Math.floor(s / 86400)} d`
}
